import type { components } from '@fluencelabs/vodopad-admin-api'
import { useCustom } from '@refinedev/core'
import { Typography } from 'antd'
import { Link } from 'react-router-dom'

import { VODOPAD_ENDPOINT } from '@/constants/constants'
import { useVmsCache } from '@/hooks/useVmsByIds'
import type { PaginatedItems } from '@/types/api'

type UserVmDto = components['schemas']['AdminUserVmDto']

interface Props {
  vmId: string
}

export function VmNameLink({ vmId }: Props) {
  const cached = useVmsCache()
  const hasProvider = cached !== null

  const vmQuery = useCustom<PaginatedItems<UserVmDto>>({
    url: `${VODOPAD_ENDPOINT}/v2/admin/vms`,
    method: 'get',
    config: { query: { id: vmId, page: 1, perPage: 1 } },
    queryOptions: {
      enabled: Boolean(vmId) && !hasProvider,
      staleTime: 5 * 60 * 1000,
    },
  })

  const name = hasProvider
    ? cached[vmId]?.name
    : (vmQuery.query.data?.data as PaginatedItems<UserVmDto> | undefined)
        ?.items?.[0]?.name

  return (
    <Link
      to={`/compute/${vmId}`}
      style={{
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textUnderlineOffset: 4,
      }}
    >
      <Typography.Text copyable={{ text: vmId }}>
        {name ?? `${vmId.slice(0, 8)}...`}
      </Typography.Text>
    </Link>
  )
}
